import styled from 'styled-components';

import { ANIM, COLORS, MOBILE, SPACE } from '@/nova/theme/tokens';

/* The three layouts as cards with the look of the editor's method cards: the chosen one in the call-to-action
   border and tint, the others on the panel border and the soft surface. */

/* Three across; one under the other on a phone. */
export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: ${SPACE[12]};

  ${MOBILE} {
    grid-template-columns: minmax(0, 1fr);
  }
`;

/* One layout, the label of its radio, so the whole card picks it: the glyph, the name and the minimum, one under
   the other in the middle of the card. */
export const Card = styled.label<{ $on: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACE[8]};
  padding: ${SPACE[20]} ${SPACE[12]};
  border-radius: 16px;
  text-align: center;
  color: ${COLORS.text};
  cursor: pointer;
  background: ${({ $on }) => ($on ? COLORS.ctaTint : COLORS.surfaceSoft)};
  border: 2px solid ${({ $on }) => ($on ? COLORS.ctaBorder : COLORS.panelBorder)};
  transition: border-color ${ANIM.INTERACT_MS}ms ${ANIM.EASE};

  &:hover {
    border-color: ${({ $on }) => ($on ? COLORS.ctaBorder : COLORS.hoverBorderLit)};
  }

  /* The ring while the radio has the keyboard's focus, the radio itself being out of sight; a click needs none. */
  &:has(input:focus-visible) {
    outline: 2px solid ${COLORS.ctaSolid};
    outline-offset: 2px;
  }

  svg {
    flex: none;
  }
`;

/* Out of sight but still the control, for assistive tech and the keyboard: the card shows the choice. */
export const Radio = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
`;

export const Name = styled.span`
  font-size: 16px;
  font-weight: 700;
`;

/** The fewest games a layout is meant for, under its name: quieter than the name. */
export const Min = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textMuted};
`;
